export const EnergyLabel = ({ eprelId }: { eprelId: string }) => {
  return (
    <a
      href={`https://eprel.ec.europa.eu/api/product/${eprelId}/labels?format=PNG`}
      class="js-energy-label-container tw:underline tw:text-fruugo-black tw:hover:no-underline tw:focus-visible:ring-2 tw:focus-visible:ring-fruugo-blue-secondary"
      target="_blank"
    >
      <img
        src={`https://eprel.ec.europa.eu/api/product/${eprelId}/nested-label`}
        width="40"
        height="24"
        onError={(event) => handleEnergyLabelImageError(event.target)}
      />
    </a>
  );
};
